import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import RenderNestedValue from './RenderNestedValue';
import BriefSection from './BriefSection';
import css from './BriefShelf.css';
import AlertMessage, { LAYOUT_OPTIONS } from '../../../../components/utilities/AlertMessage';
import { CREATIVE_TYPES } from '../consts';

const BriefShelf = ({ briefs }) => {
    const [shouldShowWarning, setShouldShowWarning] = useState(true);
    const [currentBrief, setCurrentBrief] = useState(null);

    const availableBriefs = useMemo(() => {
        return CREATIVE_TYPES.filter(creativeType => !!briefs?.[creativeType]);
    }, [briefs]);

    useEffect(() => {
        if (availableBriefs.length > 0 && !currentBrief) {
            setCurrentBrief(availableBriefs[0]);
        }
    }, [availableBriefs, currentBrief]);

    return (
        <>
            {briefs?.comments && shouldShowWarning && (
                <AlertMessage
                    level="info"
                    layout={LAYOUT_OPTIONS.EMBEDDED}
                    text={briefs.comments}
                    isClosable
                    onClose={() => setShouldShowWarning(false)}
                />
            )}
            {availableBriefs.length > 1 && (
                <BriefSection
                    availableBriefs={availableBriefs}
                    currentBrief={currentBrief}
                    onBriefGenerator={setCurrentBrief}
                />
            )}
            <div className={css.briefsContainer}>
                {currentBrief &&
                    briefs &&
                    typeof briefs === 'object' &&
                    Object.entries(briefs[currentBrief] || {}).map(([title, value]) => (
                        <RenderNestedValue key={`${title}-${value}`} title={title} value={value} depth={1} />
                    ))}
            </div>
        </>
    );
};

BriefShelf.propTypes = {
    briefs: PropTypes.object,
};

export default BriefShelf;
